// Generated by scripts/bump_version.py via .githooks/pre-commit.
// Do not edit: set the release line in the repo-root VERSION file and
// the build number follows from the commits after it.
export const APP_VERSION = "v6.17";
